module.exports = "<div class=\"type\">{{question_name}}  <span *ngIf=\"question_name_second.length > 0\">( {{ question_name_second}} ) </span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/section-break-type/section-break-type.html
// module id = ./src/app/questions-type/section-break-type/section-break-type.html
// module chunks = main